import styled from "styled-components"
import multiLineEllipsis from "@irati/ui/src/global/css/multiLineEllipsis"
import {greys} from "@irati/ui/src/global/colors"
import addBottomPadding from "@irati/ui/src/Headings/addBottomPadding"
import {minWidthMedia} from "@irati/ui/src/global/media"

export default styled.span`
  display: block;
  font-family: Lato, sans-serif;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  line-height: 26px;
  ${(props) => addBottomPadding(props)};
  ${minWidthMedia.tablet`
    font-family: Dosis, sans-serif;
    font-size: 21px;
    line-height: 26px;
    font-weight: normal;
  `}
  ${(props) => !props.lowercase && "text-transform: capitalize;"}
  ${(props) => props.deactivated && `color: ${greys.mediumDark};`}
  ${multiLineEllipsis(1)};
`
